import { render, staticRenderFns } from "./TemplateTask.vue?vue&type=template&id=031d09ca&scoped=true&"
import script from "./TemplateTask.vue?vue&type=script&lang=js&"
export * from "./TemplateTask.vue?vue&type=script&lang=js&"
import style0 from "./TemplateTask.vue?vue&type=style&index=0&id=031d09ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031d09ca",
  null
  
)

export default component.exports